// A single-choice option sends on click. Sending instantly made it unclear
// that anything was picked, so the option is marked first and the click is
// released to LiveView half a second later. Over the last stretch of that
// delay the list fades out, so the hand-off to the sent message reads as one
// motion instead of the options vanishing.
//
// The button keeps its own phx-click (and phx-target/phx-value-*): this hook
// only holds the click back. It stops the first click before it bubbles to
// LiveView's window listener, then re-clicks the same button once the delay
// is over, so LiveView sends exactly what it would have sent.
export const CONFIRM_DELAY_MS = 500
export const FADE_MS = 180
export const RESTORE_MS = 4000

export default {
  mounted() {
    this.pending = null
    this.sending = false
    this.click = event => {
      const option = event.target.closest('[data-choice-delay]')
      if (!option || !this.el.contains(option)) return
      if (option.dataset.choiceReleased === 'true') {
        delete option.dataset.choiceReleased
        return
      }
      event.preventDefault()
      event.stopPropagation()
      if (this.pending) return
      this.pending = option
      this.mark()
      this.fadeTimer = setTimeout(() => {
        this.sending = true
        this.mark()
      }, CONFIRM_DELAY_MS - FADE_MS)
      this.timer = setTimeout(() => {
        const target = this.pending
        this.pending = null
        if (!target || !target.isConnected) return
        target.dataset.choiceReleased = 'true'
        target.click()
        // If the answer is refused (a turn already running), LiveView keeps the
        // list on screen: bring it back instead of leaving it faded.
        this.restoreTimer = setTimeout(() => this.restore(), RESTORE_MS)
      }, CONFIRM_DELAY_MS)
    }
    this.el.addEventListener('click', this.click)
  },
  mark() {
    if (this.pending) {
      this.el.querySelectorAll('[data-choice-delay]').forEach(option => {
        option.setAttribute('aria-pressed', option === this.pending ? 'true' : 'false')
      })
    }
    if (this.sending) this.el.setAttribute('data-choice-sending', 'true')
  },
  restore() {
    this.sending = false
    this.el.removeAttribute('data-choice-sending')
  },
  // A patch arriving during the delay would reset aria-pressed and the fade;
  // keep both. Once the answer is sent the list stays faded until LiveView
  // replaces it with the sent message.
  updated() { this.mark() },
  destroyed() {
    clearTimeout(this.timer)
    clearTimeout(this.fadeTimer)
    clearTimeout(this.restoreTimer)
    this.el.removeEventListener('click', this.click)
  }
}
